<ng-container *ngIf="item?.socialName==='promotion'">
  <ig-image [src]="item?.cover?.source" [alt]="item?.name" class="rounded-2xl" (click)="showPromotion()"
    cls="w-full object-cover aspect-[5/5.2] rounded-2xl cursor-pointer mobile:aspect-[2/1]"></ig-image>
</ng-container>

<div *ngIf="item?.socialName!=='promotion'" #card
  class="w-full rounded-2xl relative text-white cursor-pointer transition-all hover:scale-[1.03]"
  (click)="showDetails()">
  <span *ngIf="!frontendSettings?.customSettings?.isHideEditorChoice && item?.isChoice"
    class="w-full px-2 py-2 absolute top-0 right-0 z-[1] inline-block bg-gradient-to-b from-[#b04aeacf] to-[#773bf29e] text-xs text-white text-center rounded-t-2xl">{{getItemType()==='event'
    ? editorChoiceText?.editorChoiceForEvent : editorChoiceText?.editorChoiceForPlace}}</span>
  <ig-image [src]="item?.cover?.source" [alt]="item?.name" class="rounded-2xl"
    cls="w-full object-cover aspect-[5/5.2] rounded-2xl mobile:aspect-[2/1]"></ig-image>
  <div class="w-full h-4/5 absolute bottom-0 left-0 rounded-2xl bg-gradient-to-b from-transparent to-black"
    [class.!h-full]="isShowMoreInfo">
  </div>
  <div class="absolute bottom-0 w-full p-4 mobile:pb-2">
    <div class="text-lg text-white leading-[1.35rem] mb-1" title [class.more-info-title]="isShowMoreInfo">{{item.name}}
    </div>
    <div class="text-sm text-gray-400 gap-0.5" [class.flex]="isShowMoreInfo">
      <ng-container *ngIf="getItemType()==='event'">
        <mat-icon *ngIf="isShowMoreInfo" class="!text-sm !w-[18px] !h-[18px]">timer</mat-icon>
        <div>
          <div class="leading-4" [class.!text-3xs]="isShowMoreInfo">{{item.timeTwoLines?.date}}</div>
          <div class="leading-4" [class.!text-3xs]="isShowMoreInfo">{{item.eventTimes?.length<=1 ?
              item.timeTwoLines?.time : 'Multiple times' }}</div>
          </div>
      </ng-container>
      <ng-container *ngIf="getItemType()==='place'">
        <mat-icon *ngIf="isShowMoreInfo" class="!text-sm !w-[18px] !h-[18px]">list</mat-icon>
        <div class="leading-4" [class.!text-3xs]="isShowMoreInfo">{{getDisplayCategory(item)}}</div>
      </ng-container>
    </div>

    <div *ngIf="isShowMoreInfo" class="text-3xs text-gray-400 flex gap-0.5 items-end mt-0.5">
      <mat-icon class="!text-sm !w-[18px] !min-w-[18px] !h-[18px] relative">room</mat-icon>
      <div>{{item.address?.address}}</div>
    </div>

    <ng-container *ngIf="getItemType()==='event'">
      <div *ngIf="isShowMoreInfo" class="text-3xs text-gray-400 flex gap-0.5 items-end mt-0.5">
        <mat-icon class="!text-sm !w-[18px] !h-[18px] relative">person</mat-icon>
        <div>{{item?.owner?.name}}</div>
      </div>

      <div *ngIf="isShowMoreInfo&&item.categories?.length" class="text-3xs text-gray-400 flex gap-0.5 items-end mt-0.5">
        <mat-icon class="!text-sm !w-[18px] !h-[18px] relative">list</mat-icon>
        <div>{{getCategories()}}</div>
      </div>
    </ng-container>

    <ng-container *ngIf="getItemType()==='place'">
      <div *ngIf="isShowMoreInfo&&item?.rating" class="text-3xs text-gray-400 flex gap-0.5 items-end mt-0.5">
        <mat-icon class="!text-sm !w-[18px] !h-[18px] relative">star</mat-icon>
        <div>{{item?.rating}}</div>
      </div>

      <!-- <div *ngIf="isShowMoreInfo&&item.categories?.length" class="text-3xs text-gray-400 flex gap-0.5 items-start mt-0.5">
        <mat-icon class="!text-sm !w-[18px] !h-[18px] relative">list</mat-icon>
        <div>{{getCategories()}}</div>
      </div> -->
    </ng-container>


  </div>
</div>